import { useRef, useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import AppAppBar from '../components/AppAppBar';

/**
 * Root layout — renders once, stays mounted during navigation.
 * AppAppBar never re-renders on child state changes.
 * Each page manages its own scroll via PageLayout.
 * Spacer height is measured dynamically via ResizeObserver — handles MaintenanceBanner.
 */
export default function AppLayout() {
    const appBarRef = useRef(null);
    const [appBarHeight, setAppBarHeight] = useState(64);

    useEffect(() => {
        const el = appBarRef.current;
        if (!el) return;

        // Measure immediately on mount
        setAppBarHeight(el.getBoundingClientRect().height);

        // Update on resize — banner toggling changes AppBar height
        const observer = new ResizeObserver(([entry]) => {
            setAppBarHeight(entry.contentRect.height);
        });

        observer.observe(el);

        return () => observer.disconnect();
    }, []);

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh', backgroundColor: '#0d0d1a' }}>
            <Box ref={appBarRef}>
                <AppAppBar />
            </Box>
            <Box sx={{ height: appBarHeight, flexShrink: 0 }} />
            <Box sx={{ flex: 1, minHeight: 0 }}>
                <Outlet />
            </Box>
        </Box>
    );
}
